// You can pass some outer data here
import { AFTERSALE_STATUS, TAG_TYPE, SHOP_STATUS } from '@/constants';
import _ from 'lodash';

export default function({ actionColumn = {} } = {}) {
  const afterSaleItemColumns = [
    {
      prop: 'goods_shared_cover',
      label: '商品',
      width: 300,
      renderCell(h, { row }) {
        const imageSrc = row.goods_shared_cover;
        return (
          <div class="flex item-center">
            <el-image src={imageSrc} fit="cover" style={{ width: '50px', height: '50px' }} preview-src-list={[imageSrc]}></el-image>
            <div class="flex column item-start" style="margin-left: 15px">
              <a href="#">{_.get(row, 'goods.name')}</a>
              <span>规格: {_.get(row, 'properties_value')}</span>
            </div>
          </div>
        )
      }
    },
    {
      prop: 'sku_id',
      label: '规格编码',
    },
    {
      prop: 'base_price',
      label: '单价(元)'
    },
    {
      prop: 'qty',
      label: '数量'
    },
    {
      prop: 'amount',
      label: '总金额(元)'
    }
  ]

  return [
    {
      prop: 'id',
      label: '编号',
      width: 80
    },
    {
      prop: 'order',
      label: '原订单',
      minWidth: 140,
      renderCell(h, { row }) {
        const order = row.order;
        if (order) {
          return <c-link-button to={{ name: 'orders.show', params: { id: order.id } }}>{ order.so_id }</c-link-button>
        }
      }
    },
    {
      prop: 'after_order_items',
      label: '售后项',
      width: 60,
      type: 'expand',
      renderCell(h, { row }) {
        return <c-source-table style={{ width: '660px' }} table={{ data: row.after_sale_items }} columns={afterSaleItemColumns} />
      }
    },
    {
      prop: 'buyer_account',
      label: '买家账号'
    },
    {
      prop: 'pay_amount',
      label: '支付金额(元)',
      minWidth: 100
    },
    {
      prop: 'refund',
      label: '应退金额(元)',
      sort: 'order_by',
      minWidth: 110
    },
    {
      prop: 'real_refund',
      label: '实退金额(元)',
      sort: 'order_by',
      minWidth: 110
    },
    {
      prop: 'refund_integral',
      label: '退回积分'
    },
    {
      prop: 'order.shop_status',
      label: '订单状态',
      minWidth: 130,
      renderCell(h, { row }) {
        if (row.order) {
          return <el-tag type={TAG_TYPE[row.order.shop_status]}>{ SHOP_STATUS[row.order.shop_status] }</el-tag>;
        }
      }
    },
    {
      prop: 'direct_refund',
      label: '售后类型',
      minWidth: 130,
      renderCell(h, { row }) {
        return row.direct_refund ? <el-tag type='warning'>仅退款</el-tag> : <el-tag type='success'>退货退款</el-tag>;
      }
    },
    {
      prop: 'shop_status',
      label: '售后状态',
      minWidth: 130,
      renderCell(h, { row }) {
        return <el-tag size="mini" type={TAG_TYPE[row.shop_status]}>{AFTERSALE_STATUS[row.shop_status]}</el-tag>;
      }
    },
    {
      prop: 'handle_status',
      label: '处理状态'
    },
    {
      prop: 'created_at',
      label: '发起时间',
      renderCell: 'time',
      sort: 'order_by',
      minWidth: 100
    },
    {
      prop: 'remark',
      label: '退货原因'
    },
    {
      prop: 'order_remark',
      label: '订单备注'
    },
    {
      prop: 'question_type',
      label: '退货说明',
      action: ['hide-in-table']
    },
    {
      prop: 'refund_description',
      label: '退货详细描述',
      action: ['hide-in-table']
    },
    {
      prop: 'refund_evidence',
      label: '退货凭证图',
      renderCell: {
        type: 'image',
        objectFit: 'contain',
        height: 'auto',
        width: '100px'
      },
      action: ['hide-in-table']
    },
    {
      prop: 'l_id',
      label: '物流单号',
      action: ['hide-in-table']
    },
    {
      prop: 'logistics_company',
      label: '物流公司',
      action: ['hide-in-table']
    },
    {
      prop: 'traces',
      label: '物流轨迹',
      action: ['hide-in-table'],
      renderCell(h, { row }) {
        if (row.l_id) {
          return (
            <el-popover trigger="click">
              { _.map(row.traces || [], r => (<p>{ r.time } { r.context }</p>)) }
              <a href="#" slot="reference">{ row.latest_trace_info }</a>
            </el-popover>
          );
        }
      }
    },
    {
      prop: 'logistic_evidence',
      label: '物流单凭证图',
      renderCell: {
        type: 'image',
        objectFit: 'contain',
        height: 'auto',
        width: '100px'
      },
      action: ['hide-in-table']
    },
    {
      prop: 'seller_reason',
      label: '拒绝原因',
      action: ['hide-in-table']
    },
    {
      prop: 'agreed_at',
      label: '审核通过时间',
      renderCell: 'time',
      minWidth: 120
    },
    _.merge({
      prop: 'action',
      label: '操作',
      fixed: 'right',
      width: 100,
      detail: true,
      extraAction: (h, { row }) => {
        const { id, can_agree, can_refuse, can_confirm, can_reject, can_create_fake_traces } = row;
        const agreeHandler = async() => {
          await this.$confirm('确定同意售后？', '同意售后');
          await this.$request.put(`/after_sales/${id}/agree`);
          this.$message.success('操作成功');
          this.fetchData();
        }

        const refuseHandler = async() => {
          let seller_reason = await this.$prompt('拒绝理由', '拒绝售后', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
            inputErrorMessage: '拒绝理由不能为空'
          });
          seller_reason = seller_reason.value;
          await this.$request.put(`/after_sales/${id}/refuse`, { seller_reason: seller_reason });
          this.$message.success('操作成功');
          this.fetchData();
        }

        const confirmHandler = async() => {
          await this.$confirm('确定同意退款？', '确定退款');
          await this.$request.put(`/after_sales/${id}/confirm`);
          this.$message.success('操作成功');
          this.fetchData();
        }

        const rejectHandler = async() => {
          let seller_reason = await this.$prompt('拒绝理由', '拒绝退款', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
            inputErrorMessage: '拒绝理由不能为空'
          });
          seller_reason = seller_reason.value;
          await this.$request.put(`/after_sales/${id}/reject`, { seller_reason: seller_reason });
          this.$message.success('操作成功');
          this.fetchData();
        }

        const createFakeTracesHandler = async() => {
          await this.$confirm('确定创建虚拟物流轨迹？', '虚拟物流');
          await this.$request.put(`/after_sales/${id}/create_fake_traces`);
          this.$message.success('操作成功');
          this.fetchData();
        }

        const updateRealRefund = async() => {
          let real_refund = await this.$prompt('金额', '修改退款金额', {
            inputValue: row.real_refund,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /^\d+(\.\d{1,2})?$/,
            inputErrorMessage: '格式不正确'
          });
          real_refund = real_refund.value;
          await this.$request.put(`/after_sales/${id}/update_real_refund`, { real_refund: real_refund });
          this.$message.success('操作成功');
          this.fetchData();
        }

        return [
          can_agree && {
            title: '同意',
            handler: agreeHandler,
            permission: 'after_sales.update'
          },
          can_refuse && {
            title: '拒绝',
            handler: refuseHandler,
            permission: 'after_sales.update'
          },
          can_confirm && {
            title: '同意退款',
            handler: confirmHandler,
            permission: 'after_sales.update'
          },
          can_reject && {
            title: '拒绝退款',
            handler: rejectHandler,
            permission: 'after_sales.update'
          },
          can_create_fake_traces && {
            title: '创建虚拟物流',
            handler: createFakeTracesHandler,
            permission: 'after_sales.update'
          },
          row.shop_status === 'wait_seller_agree' && {
            title: '修改退款金额',
            handler: updateRealRefund,
            permission: 'after_sales.update'
          }
        ];
      }
    }, actionColumn)
  ];
}
